import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {forgot} from '../services'

const initialValues = {
    email: '',
}

const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
        .email('Formato de correo electrónico incorrecto')
        .min(3, 'Mínimo 3 símbolos')
        .max(50, 'Máximo 50 símbolos')
        .required('Correo electronico es requerido'),
})

export function ForgotPassword() {
    const [loading, setLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
    const formik = useFormik({
        initialValues,
        validationSchema: forgotPasswordSchema,
        onSubmit: (values, {setStatus, setSubmitting}) => {
            setLoading(true)
            setHasErrors(undefined)
            setErrorMsg('')
            setTimeout(() => {
                forgot(values.email)
                    .then(({data}) => {
                        setHasErrors(data.error)
                        setLoading(false)
                        if(data.error){
                            setErrorMsg(data.message)
                            setSubmitting(false)
                        }else{
                            setTimeout(() => {
                                document.location = '/central/auth'
                            },8000);
                        }
                    })
                    .catch(() => {
                        setHasErrors(true)
                        setLoading(false)
                        setSubmitting(false)
                        setStatus('Ups. algo selió mal.')
                    })
            }, 1000)
        },
    })

    return (
        <form
            className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
            noValidate
            id='kt_login_password_reset_form'
            onSubmit={formik.handleSubmit}
        >
            <div className='text-center mb-10'>
                {/* begin::Title */}
                <h1 className='text-dark fw-bolder mb-3'>¿Has olvidado tu contraseña?</h1>
                {/* end::Title */}

                {/* begin::Link */}
                <div className='text-gray-500 fw-semibold fs-6'>
                    Ingrese su correo electrónico para restablecer su contraseña.
                </div>
                {/* end::Link */}
            </div>

            {/* begin::Title */}
            {hasErrors === true && (
                <div className='mb-lg-15 alert alert-danger'>
                    <div className='alert-text font-weight-bold'>
                        <h5 className={'text-danger'}>{errorMsg}</h5>
                        Lo sentimos, parece que se han detectado algunos errores. Inténtalo de nuevo.
                    </div>
                </div>
            )}

            {hasErrors === false && (
                <div className='mb-10 bg-light-info p-8 rounded'>
                    <div className='text-info'>Te hemos enviado un correo electrónico con instrucciones para cambiar tu
                        contraseña.
                    </div>
                </div>
            )}
            {/* end::Title */}

            {/* begin::Form group */}
            <div className='fv-row mb-8'>
                <label className='form-label fw-bolder text-gray-900 fs-6'>Correo Electrónico</label>
                <input
                    type='email'
                    placeholder=''
                    autoComplete='off'
                    {...formik.getFieldProps('email')}
                    className={clsx(
                        'form-control bg-transparent',
                        {'is-invalid': formik.touched.email && formik.errors.email},
                        {
                            'is-valid': formik.touched.email && !formik.errors.email,
                        }
                    )}
                />
                {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.email}</span>
                        </div>
                    </div>
                )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='d-flex flex-wrap justify-content-center pb-lg-0 py-10'>
                {/*disabled={formik.isSubmitting || !formik.isValid}*/}
                <button type='submit' id='kt_password_reset_submit' className='btn btn-primary me-4' disabled={loading} >

                    {!loading ?
                        <span className='indicator-label'> Restablecer mi contraseña </span>
                        :
                        <span className='indicator-progress' style={{display: 'block'}}>
                          Validando...
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    }
                </button>
                <Link to='/auth/login'>
                    <button
                        type='button'
                        id='kt_login_password_reset_form_cancel_button'
                        className='btn btn-light'
                        disabled={formik.isSubmitting || !formik.isValid}
                    >
                        Cancelar
                    </button>
                </Link>{' '}
            </div>
            {/* end::Form group */}
        </form>
    )
}
